var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.648,
    height: 13.648,
    viewBox: "0 0 13.648 13.648",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-add",
    "data-name": "Icon ionic-ios-add",
    d: "M21.764,14.939H16.639V9.815a.85.85,0,0,0-1.7,0v5.125H9.815a.85.85,0,0,0,0,1.7h5.125v5.125a.85.85,0,1,0,1.7,0V16.639h5.125a.85.85,0,1,0,0-1.7Z",
    transform: "translate(-8.965 -8.965)",
    fill: "#747478"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.9aad6c220fbf87ec9bf21531a510eaab.svg";
export { ForwardRef as ReactComponent };